import { Component } from '@angular/core';

@Component({
  selector: 'app-snackbar-header-layout',
  templateUrl: './snackbar-header-layout.component.html',
  styleUrls: ['./snackbar-header-layout.component.scss']
})
export class SnackbarHeaderLayoutComponent {

}
